import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateProjectAllocatedResourcesBudget(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>, allocatedResourcesBudget: number) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${uuid}`,
      method: HttpMethods.PATCH,
      data: { allocatedResourcesBudget },
    });
}

export { updateProjectAllocatedResourcesBudget };
